export const LOAD_REFEREE_PROJECTS = "LOAD_REFEREE_PROJECTS";
export const LOAD_REFEREE_INFO = "LOAD_REFEREE_INFO";
export const LOGOUT = "LOGOUT";
export const CLEAN_DASHBOARD_REFEREE_PROJECTS = "CLEAN_DASHBOARD_REFEREE_PROJECTS";
